var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.total >= 0
    ? _c(
        "div",
        { staticClass: "paginator" },
        [
          _c("svgicon", {
            staticClass: "arrow arrow-left",
            attrs: {
              name: "ico-chevron",
              color: "grey",
              height: "18",
              width: "18"
            },
            on: {
              click: function($event) {
                _vm.setPage(_vm.current - 1)
                _vm.handleClickDecreasePage(_vm.current - 1)
              }
            }
          }),
          _c("div", { staticClass: "page" }, [
            _c("input", {
              style: { width: _vm.inputWidth },
              attrs: { name: "current", type: "text" },
              domProps: { value: _vm.current },
              on: {
                change: function($event) {
                  return _vm.setPage($event.target.value)
                }
              }
            }),
            _c("p", [_vm._v("/ " + _vm._s(_vm.total))])
          ]),
          _c("svgicon", {
            staticClass: "arrow arrow-right",
            attrs: {
              name: "ico-chevron",
              color: "grey",
              height: "18",
              width: "18"
            },
            on: {
              click: function($event) {
                _vm.setPage(_vm.current + 1)
                _vm.handleClickIncreasePage(_vm.current + 1)
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }